<!--  -->
<template>
  <div class="container" id="container" v-title data-title="登录">
    <!-- <div class="msgPrompt" style="display:{$msg ? 'block' : 'none'}">
		<div class="mask" onclick="closePrompt();"></div>
		<div class="con-div">
			<div class="con">
				{$msg}
			</div>
			<a href="javascript:;" class="btn" onclick="closePrompt();">我知道了</a>
		</div>
	</div> -->
    <!-- <audio controls="controls">
      <source
        src="audio.zhongyishuyou.com/course/2016111011480014.mp3"
        type="audio/mpeg"
      />
      Your browser does not support the audio tag.
    </audio> -->
    <linglanHeader :isLogin="true"></linglanHeader>
    <div class="main">
      <img src="@/assets/images/login_bg.png" alt="" />
      <div class="code-wraper">
        <wxlogin
          :appid="appid"
          :scope="scope"
          :redirect_uri="redirectUri"
          href="https://syh-media.oss-cn-beijing.aliyuncs.com/css/syh_wx.css"
        ></wxlogin>
      </div>
      <div class="login-info">
        如果您在灵兰中医APP没有使用过“微信登录”，也没有在“灵兰中医”微信公众号绑定手机号登录，请您先在灵兰中医APP退出登录、重新使用“微信登录”，或在“灵兰中医”微信公众号绑定手机号登录。
      </div>
    </div>

    <!-- <div class="footer-wraper">
      <div class="footer">
        <div class="info fl">
          <p>
            本网站是为了在中医书友会微信公众号（灵兰中医App）购买视频课程的用户改善视听效果而开发，<b
              >如欲留言，还请登录灵兰中医App。</b
            >
          </p>
          <p>客服电话：18310991090</p>
        </div>
        <div class="copyright fr">
          © 2017-2019 北京灵兰精诚中医科技有限公司版权所有<br />京ICP备15057334号
        </div>
        <div class="line fr"></div>
      </div>
    </div> -->
    <div class="footer-wraper">
      <div class="footer">
        <div class="img-wraper fl">
          <img src="@/assets/images/download.jpg" alt="" />
        </div>
        <div class="info fl">
          <p>
            为了保护您的听课权益，本网站不支持与APP端、H5端同时在线，三端有且只能一端在线。如您在APP或H5端再次登录，PC端将自动退出登录。
          </p>
          <b>咨询建议请扫描二维码添加客服企业微信</b>
        </div>
        <div class="copyright fr">
          © 2017 北京灵兰精诚中医科技有限公司版权所有<br />京ICP备15057334号
          <router-link tag="a" target="_blank" :to="{ name: 'privacyPolicy' }"
            ><span style="margin-left: 15px">隐私及个人信息保护政策</span></router-link
          >
          <br />
          <router-link tag="a" target="_blank" :to="{ name: 'permit' }"
            >出版物许可</router-link
          >
        </div>
        <div class="line fr"></div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import wxlogin from "vue-wxlogin";
import linglanHeader from "@/components/header";
export default {
  components: {
    wxlogin,
    linglanHeader,
  },
  computed: {
    appid() {
      return this.$store.state.appid;
    },
    scope() {
      return this.$store.state.scope;
    },
    redirectUri() {
      return this.$store.state.redirectUri;
    },
  },
  data() {
    return {};
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    // localStorage.setItem(
    //   "token",
    //   "eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiIzMTMzOTM2MjgwNzQ4MDMyIiwiaWF0IjoxNjYyMzU4NDAwLCJzdWIiOiI5MDg4MTMzNDNAcXEuY29tIiwiaXNzIjoiYXBpLmxpbmdsYW4uY29tIiwiZXhwIjozMzI0NzE2ODAxfQ.wWJl9BxyU2aTezAH-g94toPR7A8gz7vbkn9HCRfyUx4"
    // );
    let userInfo = {
      id: "2610253098467328",
      userId: "2648044491931648",
      fuserId: "0",
      name: "Sjj",
      alias: "小谢",
      wxName: "",
      email: "174481310@qq.com",
      feature: "",
      sex: 0,
      birth: -28800,
      phone: "15059960361",
      province: "",
      provinceId: 0,
      city: "",
      cityId: 0,
      county: "",
      countyId: 0,
      address: "",
      areaType: "",
      company: "",
      professional: "",
      treatType: "",
      face:
        "https://syh-resource.oss-cn-beijing.aliyuncs.com/img/admin/20180514/122222F8HAvj.png",
      signed: "",
      about: "",
      ip: "180.111.132.91",
      comefrom: false,
      knowType: "",
      iosAccount: 10000000,
      andriodAccount: 10000000,
      account: 0,
      countScore: 0,
      countFollow: 0,
      countFollowed: 0,
      countArticle: 0,
      countView: 0,
      isEnable: true,
      isRecommend: false,
      isApprove: false,
      isFamilyMember: false,
      studyFee: 0,
      coinNum: 0,
      income: "",
      studyTime: "",
      addTime: 0,
      upTime: 1618382184,
      compress: null,
    };
    // localStorage.setItem("userInfo", JSON.stringify(userInfo));
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    console.log($(document).outerHeight(true));
    $("#container").css({ "min-height": $(document).outerHeight() + "px" });
    $(".footer-wraper").css({ display: "block" });
    // $("#container").css({ "min-height": $(document).outerHeight() + "px" });
    // $(".footer-wraper").css({ display: "block" });
  },
};
</script>

<style scoped>
/* @import url(); 引入css类 */
@import url("../../assets/css/common.css");
@import url("../../assets/css/main.css");
.container {
  padding-bottom: 200px;
  position: relative;
}
.main {
  width: 100%;
  /* height: 340px; */
  position: relative;
}
.main img {
  width: 1100px;
  height: 100%;
  margin: 0 auto;
}
.main .code-wraper {
  width: 360px;
  height: 380px;
  background: #fff;
  position: absolute;
  left: 50%;
  top: 50px;
  margin-left: -180px;
  border-radius: 8px;
  box-shadow: 0px 2px 3px #d3d2d2;
  -moz-box-shadow: 0px 2px 3px #d3d2d2;
  -webkit-box-shadow: 0px 2px 3px #d3d2d2;
}
#wxcode {
  width: 220px;
  height: 220px;
  position: relative;
}
.main .login-info {
  width: 360px;
  margin: 110px auto 50px;
  line-height: 24px;
  font-size: 14px;
  color: #585858;
}
.footer-wraper {
  display: block;
  position: absolute;
  bottom: 0;
}
.footer .line {
  width: 2px;
}
/deep/ .el-header {
  padding: 0px;
}
/* /deep/.impowerBox .qrcode{
  height: 260px  !important;
} */
/* .main .code-wraper {
  text-align: center !important;
  height: 390px;
} */
.impowerBox .title {
  font-size: 20px !important;
  color: #79b4ec !important;
  line-height: 20px !important;
  margin: 21px 0 16px !important;
}
/deep/ .qrcode {
  width: 220px !important;
  border: none !important;
  margin: 0 !important;
}
</style>
